<div [innerHtml]="innerHtml"></div>